import React, { useEffect, useRef, useState } from "react";
import * as yup from "yup";
import { Formik } from "formik";
import { Form, Button } from "react-bootstrap";
import { Breadcrumb } from "@gull";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import axios from "axios";
import { createEmployee, fetchRoles } from "app/API/EmployeeAPI"; // Assuming you have an API function for adding employees
import { serverAddress } from "constants";
import swal from "sweetalert2";
import { values } from "lodash";
import codes from "../../views/countryList";
import { validatePhoneNumber } from "../../views/phoneValidation";
import Select from "react-select";
import currencyCodes from "shared/data/currencyCodes";
import { Modal } from "react-bootstrap";
import { createSalaryMaster } from "app/API/EmployeeAPI";

const employeeFormSchema = yup.object().shape({
  first_name: yup.string().required("First name is required"),
  last_name: yup.string().required("Last name is required"),
  phone_number: yup
    .string()
    .required("Mobile Number is required")
    .matches(/^\d+$/, "Mobile Number must contain only digits")
    .test(
      "valid-phone",
      function (value) {
        if (!value) return this.createError({ message: "Mobile Number is required" });
        const countryCode = this.parent.countryCode || "91";
        const validation = validatePhoneNumber(value, countryCode);
        
        if (!validation.isValid) {
          return this.createError({ message: validation.errorMessage });
        }
        
        return true;
      }
    ),
  email_address: yup
    .string()
    .email("Invalid email address")
    .required("Email address is required"),
  designation: yup.string().required("Designation is required"),
  department: yup.string().required("Department is required"),
  address: yup.string().required("Address is required"),
  password: yup.string().required("Password is required"),
  user_name: yup.string().required("Username is required"),
  job_title: yup.string().required("Job Title is required"),
  status: yup.string().required("Status is required"),
  roles: yup.array().min(1, "At least one role is required"),
  emp_code: yup
    .number()
    .typeError("Employee Code must be a number")
    .required("Employee Code is required")
    .integer("Employee Code must be an integer")
    .min(0, "Employee Code cannot be negative"),
  countryCode: yup.string(),
});

const EmployeeCreate = () => {
  const storedToken = localStorage.getItem("token");
  const [state, setState] = useState({
    first_name: "",
    emp_code:"",
    last_name: "",
    phone_number: "",
    email_address: "",
    designation: "",
    department: "",
    address: "",
    password: "",
    user_name: "",
    job_title: "",
    base_salary: "",
    hra: "",
    allowances: "",
    gross_salary: "",
    net_salary: "",
    bonus: "",
    deductions:"",
    salary_master_id: "",
    work_start_time: "",
    work_end_time: "",
    shift_type: "",
    status: "",
    currency: "INR",
    countryCode: "91",
    role_ids: [],
    roles: [],
    token: storedToken || "",
    pf: false,
    esi: false,
  });
  const [salaryMaster, setSalaryMaster] = useState([]);
  const [roles, setRoles] = useState([]); // Store roles

  const [modalVisible, setModalVisible] = useState(false);
  const [salaryMasterData, setSalaryMasterData] = useState({
    job_title: "",
    base_salary: "",
    hra: "0",
    allowances: "0",
    gross_salary: "0",
    deductions: "0",
    net_salary: "0",
    bonus: "0",
    work_start_time: "",
    work_end_time: "",
    shift_type: "",
    errors: {},
  });

  // Fetch user from localStorage
  const user = JSON.parse(localStorage.getItem("user")) || {};
  const organizationId = localStorage.getItem("organizationId");

  useEffect(() => {
    const getSalaryMaster = async () => {
      try {
        const response = await axios.get(
          `${serverAddress}/salarymaster/getAll?organizationId=${organizationId}`,
          {
            headers: {
              Authorization: `Bearer ${state.token}`,
              "Content-Type": "application/json",
            },
          }
        );
        setSalaryMaster(response.data.salary_masters);
      } catch (error) {
        console.error("Error fetching salary master data:", error);
      }
    };

    const fetchRolesData = async () => {
      try {
        const rolesData = await fetchRoles(state.token); // Use the new fetchRoles function
        setRoles(rolesData);
      } catch (error) {
        console.error("Error fetching roles:", error);
      }
    };

    getSalaryMaster();
    fetchRolesData();
  }, [state.token, modalVisible, organizationId]);

  console.log("show salary master:", salaryMaster);

  const handleJobTitleChange = (e) => {
    const selectedJobTitle = e.target.value;

    // Find the job title details that match the selected job title
    const jobDetails = salaryMaster.find(
      (job) => job.job_title === selectedJobTitle
    );

    if (jobDetails) {
      // If a matching job title is found, update the state with the corresponding salary details
      const {
        base_salary,
        hra,
        allowances,
        gross_salary,
        net_salary,
        bonus,
        work_start_time,
        work_end_time,
        shift_type,
        deductions,
        id,
      } = jobDetails;

      // Format the time values
      const formatTime = (timeString) => {
        const [hours, minutes] = timeString.split(":");
        return `${hours.padStart(2, "0")}:${minutes.padStart(2, "0")}`;
      };

      setState((prevState) => ({
        ...prevState,
        job_title: selectedJobTitle,
        base_salary,
        hra,
        allowances,
        deductions,
        gross_salary,
        net_salary,
        bonus,
        work_start_time: formatTime(work_start_time),
        work_end_time: formatTime(work_end_time),
        shift_type,
        salary_master_id: id,
      }));
    } else {
      // If no matching job title is found, clear the salary fields
      setState((prevState) => ({
        ...prevState,
        job_title: selectedJobTitle,
        base_salary: "",
        hra: "",
        allowances: "",
        gross_salary: "",
        net_salary: "",
        bonus: 0,
        salary_master_id: "",
        work_start_time: "",
        work_end_time: "",
        shift_type: "",
      }));
    }
  };

  const handleRoleChange = (selectedRoles, { setFieldValue }) => {
    const roleIds = selectedRoles.map((role) => role.value);
    setState((prevState) => ({
      ...prevState,
      roles: roleIds,
    }));
    setFieldValue("roles", roleIds);
  };

  const moneyFields = [
    "base_salary","hra","allowances","bonus","deductions"
  ];
  const handleInputChange = (e) => {
    const { name, value } = e.target;
  
    setState((prev) => {
      const next = { ...prev, [name]: value };
  
      // only recalc if a numeric field changed
      if (moneyFields.includes(name)) {
        const totals = computeTotals(next);
        Object.assign(next, totals);
      }
      return next;
    });
  };
  

  const validatePayload = (payload) => {
    const requiredFields = [
      { field: "base_salary", label: "Base Salary" },
      { field: "gross_salary", label: "Gross Salary" },
      { field: "net_salary", label: "Net Salary" },
    ];

    for (const { field, label } of requiredFields) {
      if (!payload[field] || payload[field] === 0) {
        swal.fire({
          title: "Error!",
          text: `${label} cannot be empty or zero.`,
          type: "error",
          icon: "error",
          timer: 1500,
        });
        return false; // Return false to indicate validation failure
      }
    }
    return true; // Return true to indicate validation success
  };

  const handleSubmit = async (values, { setSubmitting, resetForm }) => {
    try {
      // Transform selected roles to include permissions
      const rolePermissions = state.roles.map((roleId) => ({
        role_id: roleId,
        can_create: true,
        can_read: true,
        can_update: true,
        can_delete: true,
      }));

      // Format the time values
      const formatTime = (timeString) => {
        if (!timeString) return "";
        const [hours, minutes] = timeString.split(":");
        return `${hours.padStart(2, "0")}:${minutes.padStart(2, "0")}:00`;
      };

      const payload = {
        first_name: values.first_name,
        emp_code:values.emp_code,
        last_name: values.last_name,
        phone_number: values.phone_number ? `+${values.countryCode}-${values.phone_number}` : "",
        email_address: values.email_address,
        designation: values.designation,
        department: values.department,
        address: values.address,
        password: values.password,
        user_name: values.user_name,
        job_title: values.job_title,
        base_salary: state.base_salary,
        hra: state.hra,
        allowances: state.allowances,
        gross_salary: state.gross_salary,
        net_salary: state.net_salary,
        bonus: state.bonus,
        salary_master_id: state.salary_master_id,
        status: values.status,
        role_ids: rolePermissions,
        token: state.token,
        currency: state.currency,
        work_start_time: formatTime(state.work_start_time),
        work_end_time: formatTime(state.work_end_time),
        shift_type: state.shift_type,
        pf: values.pf,
        esi: values.esi,
        organizationId: organizationId,
      };

      if (!validatePayload(payload)) {
        setSubmitting(false);
        return; // Stop submission if validation fails
      }

      const response = await createEmployee(payload, payload.token);

      swal.fire({
        title: "Added!",
        text: "Employee Added Successfully.",
        type: "success",
        icon: "success",
        timer: 1500,
      });
      resetForm();
      setState({
        first_name: "",
        emp_code:"",
        last_name: "",
        phone_number: "",
        email_address: "",
        designation: "",
        department: "",
        address: "",
        password: "",
        user_name: "",
        job_title: "",
        base_salary: "",
        hra: "",
        allowances: "",
        gross_salary: "",
        net_salary: "",
        bonus: "",
        salary_master_id: "",
        work_start_time: "",
        work_end_time: "",
        shift_type: "",
        status: "",
        role_ids: [],
        token: storedToken || "",
        pf: false,
        esi: false,
      });
    } catch (error) {
      console.error('Employee creation error:', error);
      console.log('Error response:', error.response);
      console.log('Error response data:', error.response?.data);
      
      // Handle specific error types
      let errorTitle = "Error!";
      let errorText = "Failed to add employee. Please try again or contact support.";
      
      if (error.response?.data) {
        const errorData = error.response.data;
        console.log('Parsed error data:', errorData);
        console.log('Error type:', errorData.errorType);
        console.log('Error message:', errorData.msg);
        console.log('Checking if errorType === DUPLICATE_EMP_CODE:', errorData.errorType === 'DUPLICATE_EMP_CODE');
        
        // Check for specific error types
        if (errorData.errorType === 'DUPLICATE_EMP_CODE') {
          console.log('Matched DUPLICATE_EMP_CODE condition');
          errorTitle = "Duplicate Employee Code";
          errorText = errorData.msg || `Employee code '${errorData.value}' already exists in this organization. Please use a different employee code.`;
        } else if (errorData.errorType === 'DUPLICATE_EMAIL') {
          console.log('Matched DUPLICATE_EMAIL condition');
          errorTitle = "Duplicate Email Address";
          errorText = errorData.msg || `Email address '${errorData.value}' is already in use. Please use a different email address.`;
        } else if (errorData.errorType === 'DUPLICATE_ENTRY') {
          console.log('Matched DUPLICATE_ENTRY condition');
          errorTitle = "Duplicate Entry";
          // Check if it's related to employee code
          if ((errorData.field && errorData.field.includes('emp_code')) || (errorData.field && errorData.field.includes('unique_emp_code_per_organization'))) {
            errorTitle = "Duplicate Employee Code";
            errorText = `Employee code '${errorData.value}' already exists in this organization. Please use a different employee code.`;
          } else {
            errorText = errorData.msg || "A duplicate entry was detected. Please check your input.";
          }
        } else if (errorData.msg) {
          console.log('Using backend error message');
          // Use the backend error message if available
          errorText = errorData.msg;
        } else if (errorData.err?.name === 'SequelizeUniqueConstraintError') {
          console.log('Matched SequelizeUniqueConstraintError condition');
          // Fallback for any unique constraint errors
          const duplicateField = errorData.err.errors?.[0]?.path;
          const duplicateValue = errorData.err.errors?.[0]?.value;
          
          if (duplicateField === 'employee.emp_code') {
            errorTitle = "Duplicate Employee Code";
            errorText = `Employee code '${duplicateValue}' already exists. Please use a different employee code.`;
          } else if (duplicateField === 'employee.email_address') {
            errorTitle = "Duplicate Email Address";
            errorText = `Email address '${duplicateValue}' is already in use. Please use a different email address.`;
          } else {
            errorTitle = "Duplicate Entry";
            errorText = `The ${duplicateField?.replace('employee.', '')} '${duplicateValue}' is already in use. Please choose a different value.`;
          }
        } else {
          console.log('No specific error type matched, using default');
        }
      } else {
        console.log('No error.response.data found');
      }
      
      console.log('Final error title:', errorTitle);
      console.log('Final error text:', errorText);
      
      swal.fire({
        title: errorTitle,
        text: errorText,
        type: "error",
        icon: "error",
        timer: 3000, // Increased timer for longer messages
      });
    }

    setSubmitting(false);
  };

  const roleOptions = roles.map((role) => ({
    value: role.id,
    label: role.role_name,
  }));

  const handleSalaryMasterInputChange = (e) => {
    const { name, value } = e.target;
  
    // inline validator
    const isMoneyField = [
      "base_salary",
      "hra",
      "allowances",
      "deductions",
      "bonus",
    ].includes(name);
    const errorMessage =
      isMoneyField && !/^\d*$/.test(value) ? "Only positive numbers are allowed" : "";
  
    setSalaryMasterData((prev) => {
      // build the **next** snapshot first
      const next = {
        ...prev,
        [name]: value,
        errors: { ...prev.errors, [name]: errorMessage },
      };
  
      // pull fresh numbers from that snapshot
      const base   = parseInt(next.base_salary || 0, 10);
      const hra    = parseInt(next.hra          || 0, 10);
      const allow  = parseInt(next.allowances   || 0, 10);
      const bonus  = parseInt(next.bonus        || 0, 10);
      const deduc  = parseInt(next.deductions   || 0, 10);
  
      const gross  = base + hra + allow + bonus;
      const net    = gross - deduc;
  
      return {
        ...next,
        gross_salary: gross.toString(),
        net_salary:   net.toString(),
      };
    });
  };
  

  const handleSalaryMasterSubmit = async () => {
    let errors = {};

    // Required fields validation
    const requiredFields = [
      "job_title",
      "base_salary",
      "work_start_time",
      "work_end_time",
      "shift_type",
    ];
    requiredFields.forEach((field) => {
      if (!salaryMasterData[field]) {
        errors[field] = "This field is required";
      }
    });

    // Numeric validation
    const numericFields = [
      "base_salary",
      "hra",
      "allowances",
      "gross_salary",
      "net_salary",
      "bonus",
      "deductions",
    ];
    numericFields.forEach((field) => {
      if (
        salaryMasterData[field] &&
        (!/^\d+$/.test(salaryMasterData[field]) ||
          parseInt(salaryMasterData[field], 10) < 0)
      ) {
        errors[field] = "Only positive numbers are allowed";
      }
    });

    // If errors exist, update state and stop form submission
    if (Object.keys(errors).length > 0) {
      setSalaryMasterData((prevData) => ({ ...prevData, errors }));
      return;
    }

    try {
      console.log("show salary master Data", salaryMasterData);
      
      // Add organizationId to salary master data
      const dataWithOrgId = {
        ...salaryMasterData,
        organizationId: organizationId
      };
      
      await createSalaryMaster(dataWithOrgId, state.token);
      setModalVisible(false);
      swal.fire({
        title: "Added!",
        text: "Salary Master Added Successfully.",
        icon: "success",
        timer: 1500,
      });

   setSalaryMasterData(   {
        job_title: "",
        base_salary: "",
        hra: "0",
        allowances: "0",
        gross_salary: "0",
        deductions: "0",
        net_salary: "0",
        bonus: "0",
        work_start_time: "",
        work_end_time: "",
        shift_type: "",
        errors: {},
      })
    } catch (error) {
      swal.fire({
        title: "Error!",
        text: "Failed to add salary master.",
        icon: "error",
        timer: 1500,
      });
    }
  };

  const computeTotals = (obj) => {
    const base  = parseInt(obj.base_salary || 0, 10);
    const hra   = parseInt(obj.hra          || 0, 10);
    const allow = parseInt(obj.allowances   || 0, 10);
    const bonus = parseInt(obj.bonus        || 0, 10);
    const ded   = parseInt(obj.deductions   || 0, 10);
  
    const gross = base + hra + allow + bonus;
    const net   = gross - ded;
    return { gross_salary: gross.toString(), net_salary: net.toString() };
  };
  

  return (
    <div>
      <Breadcrumb routeSegments={[{ name: "Add Employee" }]} />
      <div className="row">
        <div className="col-md-12">
          <div className="card mb-4">
            <div className="card-body">
              <Formik
                initialValues={state}
                validationSchema={employeeFormSchema}
                onSubmit={handleSubmit}
                validateOnChange={true}
                validateOnBlur={true}
              >
                {({
                  values,
                  errors,
                  touched,
                  handleChange,
                  handleBlur,
                  handleSubmit,
                  isSubmitting,
                  setFieldValue,
                  setFieldTouched,
                  validateField,
                }) => {
                  // Custom handler for country code change that also revalidates phone
                  const handleCountryCodeChange = (e) => {
                    handleChange(e);
                    // Trigger revalidation of the phone number field
                    setTimeout(() => {
                      if (values.phone_number) {
                        setFieldTouched('phone_number', true);
                        validateField('phone_number');
                      }
                    }, 0);
                  };
                  
                  return (
                  <form onSubmit={handleSubmit}>
                    <div className="row">
                      <div className="d-flex justify-content-end form-group align-items-center mb-2"></div>
                      <div className="col-md-6 form-group mb-3">
                        <label htmlFor="first_name">First Name</label>
                        <input
                          id="first_name"
                          name="first_name"
                          className="form-control"
                          placeholder="Enter first name"
                          type="text"
                          onChange={handleChange}
                          onBlur={handleBlur}
                          value={values.first_name}
                        />
                        {errors.first_name && touched.first_name && (
                          <div className="text-danger mt-1 ml-2">
                            {errors.first_name}
                          </div>
                        )}
                      </div>

                      <div className="col-md-6 form-group mb-3">
                        <label htmlFor="last_name">Last Name</label>
                        <input
                          id="last_name"
                          name="last_name"
                          className="form-control"
                          placeholder="Enter last name"
                          type="text"
                          onChange={handleChange}
                          onBlur={handleBlur}
                          value={values.last_name}
                        />
                        {errors.last_name && touched.last_name && (
                          <div className="text-danger mt-1 ml-2">
                            {errors.last_name}
                          </div>
                        )}
                      </div>


                      <div className="col-md-6 form-group mb-3">
                        <label htmlFor="emp_code">Employee Code</label>
                        <input
                          id="emp_code"
                          name="emp_code"
                          className="form-control"
                          placeholder="Enter employee code"
                          type="number"
                          step="1"
                          min="0"
                          onKeyDown={(e) => {
                            // Prevent decimal point, minus, 'e', and special characters
                            if (e.key === '.' || e.key === '-' || e.key === 'e' || e.key === 'E' || e.key === '+') {
                              e.preventDefault();
                            }
                          }}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          value={values.emp_code}
                        />
                        {errors.emp_code && touched.emp_code && (
                          <div className="text-danger mt-1 ml-2">
                            {errors.emp_code}
                          </div>
                        )}
                      </div>

                      <div className="col-md-6 form-group mb-3">
                        <label htmlFor="phone_number">Phone Number</label>

                        <div className="d-flex align-items-center justify-content-between">
                          <select
                            className="form-select"
                            name="countryCode"
                            style={{ width: "150px" }}
                            onChange={handleCountryCodeChange}
                            onBlur={handleBlur}
                            value={values.countryCode}
                          >
                            <option data-countrycode="IN" value="91">
                              India (+91)
                            </option>
                            <option data-countrycode="GB" value="44">
                              UK (+44)
                            </option>
                            <option data-countrycode="US" value="1">
                              USA (+1)
                            </option>
                            <optgroup label="Other countries">
                              {codes.map((country) => (
                                <option
                                  key={country.code}
                                  data-countrycode={country.code}
                                  value={country.dial_code.replace('+', '')}
                                >
                                  {country.name} ({country.dial_code})
                                </option>
                              ))}
                            </optgroup>
                          </select>

                          <input
                            id="phone_number"
                            name="phone_number"
                            className="form-control"
                            placeholder="Enter phone number"
                            type="text"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.phone_number}
                            maxLength="15"
                          />
                        </div>
                        {errors.phone_number && touched.phone_number && (
                          <div className="text-danger mt-1 ml-2">
                            {errors.phone_number}
                          </div>
                        )}
                      </div>

                      <div className="col-md-6 form-group mb-3">
                        <label htmlFor="email_address">Email Address</label>
                        <input
                          id="email_address"
                          name="email_address"
                          className="form-control"
                          placeholder="Enter email address"
                          type="email"
                          onChange={handleChange}
                          onBlur={handleBlur}
                          value={values.email_address}
                        />
                        {errors.email_address && touched.email_address && (
                          <div className="text-danger mt-1 ml-2">
                            {errors.email_address}
                          </div>
                        )}
                      </div>
                      <div className="col-md-6 form-group mb-3">
                        <label htmlFor="roles">Roles</label>
                        <Select
                          id="roles"
                          name="roles"
                          isMulti
                          options={roleOptions}
                          className="basic-multi-select"
                          classNamePrefix="select"
                          onChange={(selectedOptions) =>
                            handleRoleChange(selectedOptions, { setFieldValue })
                          }
                          value={roleOptions.filter((option) =>
                            values.roles.includes(option.value)
                          )}
                        />
                        {errors.roles && touched.roles && (
                          <div className="text-danger mt-1 ml-2">
                            {errors.roles}
                          </div>
                        )}
                      </div>
                      <div className="col-md-6 form-group mb-3">
                        <label htmlFor="designation">Designation</label>
                        <select
                          id="designation"
                          name="designation"
                          className="form-select"
                          onChange={handleChange}
                          onBlur={handleBlur}
                          value={values.designation}
                        >
                          <option disabled value="">
                            Please select a Designation
                          </option>
                          <option value="admin">Admin</option>
                          <option value="sales">Sales</option>
                          <option value="purchase">Purchase</option>
                          <option value="orders">
                            Order Handling and Production
                          </option>
                          <option value="store">Store</option>
                          <option value="storepurchase">
                            Store & Purchase
                          </option>
                        </select>
                        {errors.designation && touched.designation && (
                          <div className="text-danger mt-1 ml-2">
                            {errors.designation}
                          </div>
                        )}
                      </div>

                      <div className="col-md-6 form-group mb-3">
                        <label htmlFor="department">Department</label>
                        <select
                          id="department"
                          name="department"
                          className="form-select"
                          onChange={handleChange}
                          onBlur={handleBlur}
                          value={values.department}
                        >
                          <option disabled value="">
                            Please select Department
                          </option>
                          <option value="admin">Admin</option>
                          <option value="sales">Sales</option>
                          <option value="purchase">Purchase</option>
                          <option value="orders">
                            Order Handling and Production
                          </option>
                          <option value="store">Store</option>
                          <option value="storePurchase">
                            Store & Purchase
                          </option>
                        </select>
                        {errors.department && touched.department && (
                          <div className="text-danger mt-1 ml-2">
                            {errors.department}
                          </div>
                        )}
                      </div>

                      <div className="col-md-6 form-group mb-3">
                        <label htmlFor="address">Address</label>
                        <input
                          id="address"
                          name="address"
                          className="form-control"
                          placeholder="Enter address"
                          type="text"
                          onChange={handleChange}
                          onBlur={handleBlur}
                          value={values.address}
                        />
                        {errors.address && touched.address && (
                          <div className="text-danger mt-1 ml-2">
                            {errors.address}
                          </div>
                        )}
                      </div>

                      <div className="col-md-6 form-group mb-3">
                        <label htmlFor="password">Password</label>
                        <input
                          id="password"
                          name="password"
                          className="form-control"
                          placeholder="Enter password"
                          type="password"
                          onChange={handleChange}
                          onBlur={handleBlur}
                          value={values.password}
                        />
                        {errors.password && touched.password && (
                          <div className="text-danger mt-1 ml-2">
                            {errors.password}
                          </div>
                        )}
                      </div>

                      <div className="col-md-6 form-group mb-3">
                        <label htmlFor="user_name">Username</label>
                        <input
                          id="user_name"
                          name="user_name"
                          className="form-control"
                          placeholder="Enter username"
                          type="text"
                          onChange={handleChange}
                          onBlur={handleBlur}
                          value={values.user_name}
                        />
                        {errors.user_name && touched.user_name && (
                          <div className="text-danger mt-1 ml-2">
                            {errors.user_name}
                          </div>
                        )}
                      </div>
                      <div className="col-md-6 form-group mb-3">
                        <label htmlFor="job_title">Job Title</label>
                        <select
                          id="job_title"
                          name="job_title"
                          className="form-select"
                          onChange={(e) => {
                            handleJobTitleChange(e); // Your existing function to update local state
                            setFieldValue("job_title", e.target.value); // Update Formik state
                          }}
                          onBlur={handleBlur}
                          value={state.job_title}
                        >
                          <option disabled value="">
                            Please select Job Title
                          </option>
                          {salaryMaster.map((item, key) => (
                            <option key={key} value={item.job_title}>
                              {item.job_title}
                            </option>
                          ))}
                        </select>
                        {errors.job_title && touched.job_title && (
                          <div className="text-danger mt-1 ml-2">
                            {errors.job_title}
                          </div>
                        )}
                      </div>

                      <div className="col-md-6 form-group mb-3">
                        <label htmlFor="pf" className="ul-form__label"></label>
                        <div className="ul-form__radio-inline">
                          <label className="ul-radio__position radio radio-primary form-check-inline">
                            <input
                              type="checkbox"
                              name="pf"
                              onChange={(e) =>
                                handleChange({
                                  target: {
                                    name: "pf",
                                    value: e.target.checked,
                                  },
                                })
                              }
                              checked={values.pf === true}
                            />
                            <span className="ul-form__radio-font">P.F</span>
                            <span className="checkmark"></span>
                          </label>
                          {errors.pf && touched.pf && (
                            <div className="text-danger mt-1 ml-2">
                              {errors.pf}
                            </div>
                          )}
                          <label className="ul-radio__position radio radio-primary">
                            <input
                              type="checkbox"
                              name="esi"
                              onChange={(e) =>
                                handleChange({
                                  target: {
                                    name: "esi",
                                    value: e.target.checked,
                                  },
                                })
                              }
                              checked={values.esi === true}
                            />
                            <span className="ul-form__radio-font">E.S.I</span>
                            <span className="checkmark"></span>
                          </label>
                          {errors.esi && touched.esi && (
                            <div className="text-danger mt-1 ml-2">
                              {errors.esi}
                            </div>
                          )}
                        </div>
                      </div>

                      {state.job_title && (
                        <>
                          <div className="col-md-6 form-group mb-3">
                            <label htmlFor="status">Status</label>
                            <select
                              id="status"
                              name="status"
                              className="form-control"
                              onChange={handleChange}
                              onBlur={handleBlur}
                              value={values.status}
                            >
                              <option disabled value="">
                                Please select Status
                              </option>
                              <option value="pending">Pending</option>
                              <option value="active">Active</option>
                              <option value="inactive">Inactive</option>
                              <option value="terminated">Terminated</option>
                            </select>
                            {errors.status && touched.status && (
                              <div className="text-danger mt-1 ml-2">
                                {errors.status}
                              </div>
                            )}
                          </div>
                          <div className="col-md-6 form-group mb-3">
                            <label htmlFor="base_salary">Base Salary</label>
                            <input
                              id="base_salary"
                              name="base_salary"
                              className="form-control"
                              // placeholder="Enter username"
                              type="text"
                              onChange={handleInputChange}
                              onBlur={handleBlur}
                              value={state.base_salary}
                            />
                            {errors.base_salary && touched.base_salary && (
                              <div className="text-danger mt-1 ml-2">
                                {errors.base_salary}
                              </div>
                            )}
                          </div>
                          <div className="col-md-6 form-group mb-3">
                            <label htmlFor="hra">HRA</label>
                            <input
                              id="hra"
                              name="hra"
                              className="form-control"
                              // placeholder="Enter username"
                              type="text"
                              onChange={handleInputChange}
                              onBlur={handleBlur}
                              value={state.hra}
                            />
                            {errors.hra && touched.hra && (
                              <div className="text-danger mt-1 ml-2">
                                {errors.hra}
                              </div>
                            )}
                          </div>
                          
                          <div className="col-md-6 form-group mb-3">
                            <label htmlFor="allowances">Allowances</label>
                            <input
                              id="allowances"
                              name="allowances"
                              className="form-control"
                              // placeholder="Enter username"
                              type="text"
                              onChange={handleInputChange}
                              onBlur={handleBlur}
                              value={state.allowances}
                            />
                            {errors.allowances && touched.allowances && (
                              <div className="text-danger mt-1 ml-2">
                                {errors.allowances}
                              </div>
                            )}
                          </div>
                          <div className="col-md-6 form-group mb-3">
                            <label htmlFor="gross_salary">Gross Salary</label>
                            <input
                              id="gross_salary"
                              name="gross_salary"
                              className="form-control"
                              // placeholder="Enter username"
                              type="text"
                              onChange={handleInputChange}
                              disabled
                              onBlur={handleBlur}
                              value={state.gross_salary}
                            />
                            {errors.gross_salary && touched.gross_salary && (
                              <div className="text-danger mt-1 ml-2">
                                {errors.gross_salary}
                              </div>
                            )}
                          </div>
                          <div className="col-md-6 form-group mb-3">
                            <label htmlFor="deductions">Deductions</label>
                            <input
                              id="deductions"
                              name="deductions"
                              className="form-control"
                              // placeholder="Enter username"
                              type="text"
                              onChange={handleInputChange}
                              onBlur={handleBlur}
                              value={state.deductions}
                            />
                            {errors.deductions && touched.deductions && (
                              <div className="text-danger mt-1 ml-2">
                                {errors.deductions}
                              </div>
                            )}
                          </div>
                          <div className="col-md-6 form-group mb-3">
                            <label htmlFor="net_salary">Net Salary</label>
                            <input
                              id="net_salary"
                              name="net_salary"
                              className="form-control"
                              // placeholder="Enter username"
                              disabled
                              type="text"
                              onChange={handleInputChange}
                              onBlur={handleBlur}
                              value={state.net_salary}
                            />
                            {errors.net_salary && touched.net_salary && (
                              <div className="text-danger mt-1 ml-2">
                                {errors.net_salary}
                              </div>
                            )}
                          </div>
                          <div className="col-md-6 form-group mb-3">
                            <label htmlFor="bonus">Bonus</label>
                            <input
                              id="bonus"
                              name="bonus"
                              className="form-control"
                              // placeholder="Enter username"
                              type="text"
                              onChange={handleInputChange}
                              onBlur={handleBlur}
                              value={state.bonus}
                            />
                            {errors.bonus && touched.bonus && (
                              <div className="text-danger mt-1 ml-2">
                                {errors.bonus}
                              </div>
                            )}
                          </div>
                          <div className="col-md-6 form-group mb-3">
                            <label htmlFor="work_start_time">
                              Work Start Time
                            </label>
                            <input
                              id="work_start_time"
                              name="work_start_time"
                              className="form-control"
                              type="time"
                              onChange={handleInputChange}
                              onBlur={handleBlur}
                              value={state.work_start_time}
                            />
                            {errors.work_start_time &&
                              touched.work_start_time && (
                                <div className="text-danger mt-1 ml-2">
                                  {errors.work_start_time}
                                </div>
                              )}
                          </div>
                          <div className="col-md-6 form-group mb-3">
                            <label htmlFor="work_end_time">Work End Time</label>
                            <input
                              id="work_end_time"
                              name="work_end_time"
                              className="form-control"
                              type="time"
                              onChange={handleInputChange}
                              onBlur={handleBlur}
                              value={state.work_end_time}
                            />
                            {errors.work_end_time && touched.work_end_time && (
                              <div className="text-danger mt-1 ml-2">
                                {errors.work_end_time}
                              </div>
                            )}
                          </div>
                          <div className="col-md-6 form-group mb-3">
                            <label htmlFor="shift_type">Shift Type</label>
                            <select
                              className="form-control"
                              id="shift_type"
                              name="shift_type"
                              value={state.shift_type}
                              onChange={(e) => {
                                handleInputChange(e);
                                setFieldValue("shift_type", e.target.value);
                              }}
                              onBlur={handleBlur}
                            >
                              <option value="" disabled>
                                --Select Shift--
                              </option>
                              <option value="morning">Morning</option>
                              <option value="evening">Evening</option>
                              <option value="night">Night</option>
                            </select>
                            {errors.shift_type && touched.shift_type && (
                              <div className="text-danger mt-1 ml-2">
                                {errors.shift_type}
                              </div>
                            )}
                          </div>
                          <div className="col-md-6 form-group mb-3">
                            <label htmlFor="shift_type">Currency</label>
                            <select
                              className="form-control"
                              id="currency"
                              name="currency"
                              value={state.currency}
                              onChange={(e) => {
                                handleInputChange(e);
                                setFieldValue("currency", e.target.value);
                              }}
                              onBlur={handleBlur}
                            >
                              <option value="">Select Currency</option>
                              {currencyCodes?.map((currency, index) => (
                                <option
                                  key={`${currency.AlphabeticCode}-${index}`}
                                  value={currency.AlphabeticCode}
                                >
                                  {currency.Currency} ({currency.AlphabeticCode}
                                  )
                                </option>
                              ))}
                            </select>
                            {errors.shift_type && touched.shift_type && (
                              <div className="text-danger mt-1 ml-2">
                                {errors.shift_type}
                              </div>
                            )}
                          </div>
                        </>
                      )}

                      <div className="form-group d-flex gap-3">
                        <Button
                          className="mt-2"
                          type="submit"
                          disabled={isSubmitting}
                        >
                          Submit
                        </Button>

                        <Button
                          className="mt-2"
                          onClick={() => setModalVisible(true)}
                        >
                          Add Salary Master
                        </Button>
                      </div>
                    </div>
                  </form>
                );}}
              </Formik>
            </div>
          </div>
        </div>
      </div>
      <Modal show={modalVisible} onHide={() => setModalVisible(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Add Salary Master</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {/* Job Title */}
          <Form.Group>
            <Form.Label>Job Title</Form.Label>
            <Form.Control
              type="text"
              name="job_title"
              value={salaryMasterData.job_title}
              onChange={handleSalaryMasterInputChange}
            />
            {salaryMasterData.errors?.job_title && (
              <div className="text-danger">
                {salaryMasterData.errors.job_title}
              </div>
            )}
          </Form.Group>

          {/* Salary Fields */}
          {["base_salary", "hra", "allowances", "deductions","bonus"].map((field) => (
            <Form.Group key={field}>
              <Form.Label>
                {field
                  .split("_") // Split words by underscore
                  .map((word) => word.charAt(0).toUpperCase() + word.slice(1)) // Capitalize first letter of each word
                  .join(" ")}{" "}
                {/* Join words back with space */}
              </Form.Label>
              <Form.Control
                type="text"
                name={field}
                value={salaryMasterData[field]}
                onChange={handleSalaryMasterInputChange}
              />
              {salaryMasterData.errors?.[field] && (
                <div className="text-danger">
                  {salaryMasterData.errors[field]}
                </div>
              )}
            </Form.Group>
          ))}

          <Form.Group>
            <Form.Label>Gross Salary</Form.Label>
            <Form.Control
              type="text"
              name="gross_salary"
              value={salaryMasterData.gross_salary}
              disabled
            />
          </Form.Group>

          <Form.Group>
            <Form.Label>Net Salary</Form.Label>
            <Form.Control
              type="text"
              name="net_salary"
              value={salaryMasterData.net_salary}
              disabled
            />
          </Form.Group>

          {/* Work Start Time */}
          <Form.Group>
            <Form.Label>Work Start Time</Form.Label>
            <Form.Control
              type="time"
              name="work_start_time"
              value={salaryMasterData.work_start_time}
              onChange={handleSalaryMasterInputChange}
            />
            {salaryMasterData.errors?.work_start_time && (
              <div className="text-danger">
                {salaryMasterData.errors.work_start_time}
              </div>
            )}
          </Form.Group>

          {/* Work End Time */}
          <Form.Group>
            <Form.Label>Work End Time</Form.Label>
            <Form.Control
              type="time"
              name="work_end_time"
              value={salaryMasterData.work_end_time}
              onChange={handleSalaryMasterInputChange}
            />
            {salaryMasterData.errors?.work_end_time && (
              <div className="text-danger">
                {salaryMasterData.errors.work_end_time}
              </div>
            )}
          </Form.Group>

          {/* Shift Type Dropdown */}
          <Form.Group>
            <Form.Label>Shift Type</Form.Label>
            <Form.Control
              as="select"
              name="shift_type"
              value={salaryMasterData.shift_type}
              onChange={handleSalaryMasterInputChange}
            >
              <option value="">Select Shift Type</option>
              <option value="morning">Morning</option>
              <option value="evening">Evening</option>
            </Form.Control>
            {salaryMasterData.errors?.shift_type && (
              <div className="text-danger">
                {salaryMasterData.errors.shift_type}
              </div>
            )}
          </Form.Group>
        </Modal.Body>

        <Modal.Footer>
          <Button variant="secondary" onClick={() => setModalVisible(false)}>
            Close
          </Button>
          <Button variant="primary" onClick={handleSalaryMasterSubmit}>
            Add Salary Master
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default EmployeeCreate;
